import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { HrUserAuthenticationService } from "src/app/core/storage/authentication-hruser.service";
import { ShowregisterloginService } from "src/app/services/showregisterlogin.service";
import { ApidataService } from "src/app/services/apidata.service";

@Component({
  selector: "app-hr_registration",
  templateUrl: "./hr_registration.component.html",
  styleUrls: ["./hr_registration.component.css"],
})
export class HrregistrationComponent implements OnInit {
  public horizontalPosition: MatSnackBarHorizontalPosition = "center";
  public verticalPosition: MatSnackBarVerticalPosition = "bottom";
  public registerForm: FormGroup;
  public resetForm: FormGroup;
  public changePassForm: FormGroup;
  public showEmail = false;
  public signIn: any;
  public showTimer = true;
  public showResend = true;
  public veryfyOtp = true;
  public addloginForm: FormGroup;
  public showRegister = false;
  public showLogin = true;
  public showForgot = true;
  public changePass = true;
  public otp: any;
  public messOtp: any;
  BlockedErr = true;
  WrongIdPassErr = true;
  public backendCrashErr: number = 0;

  val: any;
  isvalidconfirmpassword: boolean;
  email_error = true;
  Toggledata1 = true;
  Toggledata2 = true;
  Toggledata3 = true;
  public findAccountErr = true;
  sendOtpDisable = false;
  interval: NodeJS.Timer;
  display: number;

  /////////////////////

  title = "Register";
  ////////////////////

  constructor(
    private apicall: ApidataService,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private hrUserAuthenticationService: HrUserAuthenticationService,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private cookieService: CookieService,
    private hr_registrationS: ShowregisterloginService,
    private titleMeta: Title,
    private meta: Meta
  ) { }

  ngOnInit() {
    ///////////////////////meta tag/////////////////

    this.meta.addTags([
      { charset: "UTF-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { name: "date", content: "2020-02-10", scheme: "YYYY-MM-DD" },
      {
        name: "keywords",
        content:
          " How to register in HRM King, Registration process in HRM King, How to register & login, best Payroll software Enroll forever free , always free, liftime free ,Register For free forever hrmking best payroll and hr management software,use forever for hrmking software",
      },
      { name: "author", content: "Srmak Technological System Private Limited" },
      { name: "robots", content: "index, follow" },
    ]);

    ////////////////////////title meta///////////////////////

    this.titleMeta.setTitle(this.title);

    /////////////////////////////////////////////////
    let queryLogin = this.route.snapshot.queryParams["signUp"];
    if (queryLogin == "signIn") {
      this.showLogin = false;
      this.showRegister = true;
      this.hr_registrationS.hr_registrationSubject.subscribe((data) => {
        if (data == "signIn") {
          this.showLogin = false;
          this.showRegister = true;
        } else if (data == "signUp") {
          this.showLogin = true;
          this.showRegister = false;
        }
      });
    }

    this.registerForm = this.formBuilder.group({
      companyName: [''],
      firstName: [
        "",
        [
          Validators.required,
          Validators.pattern("^[A-Za-z][A-Za-z'-]+([ A-Za-z][A-Za-z'-]+)*"),
        ],
      ],
      lastName: [
        "",
        [
          Validators.required,
          Validators.pattern("^[A-Za-z][A-Za-z'-]+([ A-Za-z][A-Za-z'-]+)*"),
        ],
      ],
      email: [
        "",
        [
          Validators.required,
          Validators.pattern(
            "^[_a-z0-9-+]+(.[_a-z0-9-]+)*@[a-z0-9-]+(.[a-z0-9]+)*(.[a-z]{2,})$"
          ),
        ],
      ],
      phone: [
        "",
        [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")],
      ],
      employeeCount: [''],
      gender: [""],
      password: [
        "",
        [
          Validators.required,
          Validators.pattern(
            "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$"
          ),
        ],
      ],

      confirmPassword: ["", [Validators.required]],
    });

    this.registerForm.patchValue({
      securityQues: "Please select your Security Question",
    });
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  registerUsers() {
    if (this.registerForm.invalid) {
      this.markFormGroupTouched(this.registerForm);
      return;
    }
    if (this.registerForm.valid) {
      if (
        this.registerForm.value.password !=
        this.registerForm.value.confirmPassword
      ) {
        this.isvalidconfirmpassword = true;
      } else {
        this.isvalidconfirmpassword = false;
        sessionStorage.setItem("companyName", this.registerForm.value.companyName)
        this.saveData();
      }
    }
  }

  saveData() {
    let obj = {
      firstName: this.registerForm.value.firstName,
      lastName: this.registerForm.value.lastName,
      email: this.registerForm.value.email,
      phone: this.registerForm.value.phone,
      password: this.registerForm.value.password,
      //gender: this.registerForm.value.gender,
      gender: ''
    };

    this.http
      .post(this.apicall.api_baseurl + "mainadmin/create/registration", obj)
      .subscribe(
        (res: any) => {
          this.backendCrashErr = 0;
          if (res.result == 0) {
            this.hrUserAuthenticationService.login(
              res.data._id,
              res.data.id,
              res.data.corporateId,
              res.data.email,
              res.data.firstName,
              res.data.lastName,
              res.data.phone
            );
            window.location.replace(this.apicall.base_url + "products");
          } else if (res.result == 1) {
            this.email_error = false;
          }
        },
        (error) => {
          this.backendCrashErr = 1;
        }
      );
  }

  iconLogle(val) {
    if (val == "passRegister") {
      this.Toggledata1 = !this.Toggledata1;
    }
    if (val == "confirm") {
      this.Toggledata3 = !this.Toggledata3;
    }
    if (val == "passLogin") {
      this.Toggledata2 = !this.Toggledata2;
    }
  }
  loginOnly() {
    this.showLogin = false;
    this.showRegister = true;
    this.showForgot = true;
    this.showEmail = true;
    this.veryfyOtp = true;
    this.changePass = true;
  }
}
